import store from '@ps/store'
import { IvSegmentVideo } from './types'
import { TrackFrameUnit } from '@com/components/timeline-panel/types'

export function resetCursorToScoped(mergedTracktarget: IvSegmentVideo): void {
  const currentFrame = store.state.ivTimeline.currentFrame
  const setCurrentFrame = (v: TrackFrameUnit) =>
    store.commit('ivTimeline/updateCurrentFrame', v)

  // 光标
  if (currentFrame < mergedTracktarget.start) {
    setCurrentFrame(mergedTracktarget.start)
  } else if (
    currentFrame >=
    mergedTracktarget.start + mergedTracktarget.frames - 1
  ) {
    setCurrentFrame(mergedTracktarget.start + mergedTracktarget.frames - 1)
  }
}
